/** One shared date scale for the line, bars, axis labels and pointer selection. */
export const growthPointX = (index: number, count: number, width: number) =>
  count <= 1 ? width / 2 : (index / (count - 1)) * width;

export const growthIndexAtX = (
  position: number,
  count: number,
  width: number,
) =>
  count <= 1 || width <= 0
    ? 0
    : Math.max(
        0,
        Math.min(count - 1, Math.round((position / width) * (count - 1))),
      );

/** Bars stay inside their date's hit area, including edge dates. */
export const growthBarBounds = (
  index: number,
  count: number,
  width: number,
) => {
  const barWidth = Math.min(
    36,
    (Math.max(0, width) / Math.max(1, count)) * 0.44,
  );
  const left = Math.max(
    0,
    Math.min(
      width - barWidth,
      growthPointX(index, count, width) - barWidth / 2,
    ),
  );
  return {
    x: left,
    width: barWidth,
  };
};

/** CSS percentages resolve against the label itself, so any label width fits. */
export const growthLabelTransform = (anchor: number, plotWidth: number) =>
  `translateX(clamp(${-anchor}px, -50%, calc(${plotWidth - anchor}px - 100%)))`;
